{
  "nl": {
    "ticket_category": {
      "Decisions": "Beslissing",
      "Issue": "Nazorg",
      "Other": "Regulier",
      "labels": {
        "ticket_category": "Type"
      }
    }
  }
}
